import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-4">
          热门漫画推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">
          精选高分漫画，每一部都值得从头追到尾
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {cardsData.map((card) => (
            <div
              key={card.title}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-white text-xs rounded-md font-medium">
                  {card.tag}
                </span>
              </div>
              <div className="p-3">
                <h3 className="font-heading text-sm text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors truncate">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-1">{card.subtitle}</p>
                <p className="text-xs text-foreground-600 leading-relaxed hidden sm:block line-clamp-2">
                  {card.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}